<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-meeting-room-off`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 13.07l4 4V42h18v-6.93l4 4V42h2.929l4 4H8a2 2 0 01-2-2V13.07zM5.657 2.828l39.598 39.598a1 1 0 010 1.415l-1.414 1.414a1 1 0 01-1.415 0L2.828 5.657a1 1 0 010-1.414l1.415-1.415a1 1 0 011.414 0zm26.309 1.214c.022.121.034.245.034.37V10h8a2 2 0 012 2v22.929l-4-4V14h-6v10.929l-4-4V7L16.279 9.209l-3.58-3.58L29.63 2.446a2 2 0 012.336 1.596z"/></svg>
</template>
<script>

export default {
  name: 'IconMeetingRoomOff',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
